import { AfterBreak, Break, Day, Hours, LangAttendIn, LangAttendOut, LangEmpty, LangTotalWorkingHours, Type, maxBreak } from '../../../../constant/languange'
import { connect, mapStateToProps } from '../../../../helpers/Common'

const Schedules = ({ redux, val }) => {
  return (
    <div className='table-responsive my-3 text-center'>
      <table className={`table table-sm ${redux.darkModeOn ? 'table-dark bg-dark' : ''}`}>
        <thead>
          <tr>
            <th scope='col' className='text-center align-middle'>{Day}</th>
            <th scope='col' className='text-center align-middle'>{Type}</th>
            <th scope='col' className='text-center align-middle'>{LangAttendIn}</th>
            <th scope='col' className='text-center align-middle'>{LangAttendOut}</th>
            <th scope='col' className='text-center align-middle' style={{ minWidth: 130 }}>{LangTotalWorkingHours}</th>
            <th scope='col' className='text-center align-middle'>{Break}</th>
            <th scope='col' className='text-center align-middle'>{AfterBreak}</th>
            <th scope='col' className='text-center align-middle'>{maxBreak}</th>
          </tr>
        </thead>
        <tbody>
          {val.map((item, i) => (
            <tr key={i}>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{item?.day}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary text-nowrap' : 'text-nowrap'}`}>{item?.type_name || LangEmpty}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{+item?.type_id === 2 ? LangEmpty : item?.time_in || LangEmpty}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{+item?.type_id === 2 ? LangEmpty : item?.time_out || LangEmpty}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{+item?.type_id === 2 ? LangEmpty : item?.total_working_hours && item?.total_working_hours !== null ? `${item?.total_working_hours} ${Hours}` : LangEmpty}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{+item?.type_id === 2 ? LangEmpty : item?.break_range_start || LangEmpty}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{+item?.type_id === 2 ? LangEmpty : item?.break_range_end || LangEmpty}</td>
              <td className={`${redux.darkModeOn ? 'border-secondary' : ''}`}>{+item?.type_id === 2 ? LangEmpty : item?.break_max_minutes || LangEmpty}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default connect(mapStateToProps)(Schedules)
